export default "__VITE_ASSET__DoLzeKvO__"